import { render, staticRenderFns } from "./articleEdit.vue?vue&type=template&id=fa433120&scoped=true&"
import script from "./articleEdit.vue?vue&type=script&lang=js&"
export * from "./articleEdit.vue?vue&type=script&lang=js&"
import style0 from "./articleEdit.vue?vue&type=style&index=0&id=fa433120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa433120",
  null
  
)

export default component.exports